export default __webpack_public_path__ + "static/media/BrandocVillageWest.ea54a2fd.jpg";